export const MAX_BINARY_ROSTER_BYTES = 5 * 1024 * 1024;
export function readBinaryRoster(buffer, kind, signal) {
  return new Promise((resolve,reject)=>{
    if(signal?.aborted) { reject(Error('Lecture annulée.')); return; }
    if(buffer.byteLength > MAX_BINARY_ROSTER_BYTES) { reject(Error('Fichier limité à 5 Mo.')); return; }
    if(typeof Worker === 'undefined') { reject(Error('Ce navigateur ne prend pas en charge la lecture locale. Essayez un navigateur récent ou un export CSV.')); return; }
    const worker=new Worker(`${process.env.PUBLIC_URL || ''}/local-roster/worker.js`);
    let timer;
    const finish=(error,result)=>{clearTimeout(timer);signal?.removeEventListener('abort',abort);worker.terminate();error?reject(error):resolve(result);};
    const abort=()=>finish(Error('Lecture annulée.'));
    signal?.addEventListener('abort',abort,{once:true});
    worker.onmessage=({data})=>finish(data.error?Error(data.error):null,data.result);
    worker.onerror=()=>finish(Error('Lecture impossible. Le fichier peut être corrompu ou ce navigateur incompatible. Essayez un export CSV.'));
    timer=setTimeout(()=>finish(Error('Lecture trop longue (30 secondes). Réduisez le fichier ou exportez la liste en CSV.')),30000);
    worker.postMessage({buffer,kind},[buffer]);
  });
}
